// import React, { useEffect, useState } from "react";
// import { useParams, useNavigate } from "react-router-dom";

// const CustomerDetails = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();

//   const [customer, setCustomer] = useState(null);

//   // weekly interest payments
//   const [payments, setPayments] = useState([]);

//   // original amount payments
//   const [originalPayments, setOriginalPayments] = useState([]);

//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     fetchCustomerData();
//   }, [id]);

//   const fetchCustomerData = async () => {
//     try {
//       /* 1️⃣ CUSTOMER */
//       const customerRes = await fetch(
//         `http://localhost/erp/customers/get.php?id=${id}`,
//       );
//       const customerData = await customerRes.json();

//       if (!customerData.status) {
//         alert("Customer not found");
//         navigate("/admin/customers");
//         return;
//       }

//       setCustomer(customerData.customer);

//       /* 2️⃣ WEEKLY INTEREST PAYMENTS (EXISTING) */
//       const paymentsRes = await fetch(`http://localhost/erp/payments/list.php`);
//       const paymentsData = await paymentsRes.json();

//       const filteredWeekly = (paymentsData.payments || []).filter(
//         (p) => Number(p.customer_id) === Number(id),
//       );
//       setPayments(filteredWeekly);

//       /* 3️⃣ ORIGINAL AMOUNT PAYMENTS */
//       const originalRes = await fetch(
//         `http://localhost/erp/payments/list-original-payments.php`,
//       );
//       const originalData = await originalRes.json();

//       const filteredOriginal = (originalData.payments || []).filter(
//         (p) => Number(p.customer_id) === Number(id),
//       );
//       setOriginalPayments(filteredOriginal);
//     } catch (err) {
//       console.error(err);
//     }

//     setLoading(false);
//   };

//   /* ================= WEEKLY LOGIC (UNCHANGED) ================= */

//   const getCompletedWeeks = (givenDate) => {
//     const start = new Date(givenDate);
//     const today = new Date();
//     start.setHours(0, 0, 0, 0);
//     today.setHours(0, 0, 0, 0);
//     const diffDays = Math.floor((today - start) / 86400000);
//     return Math.floor(diffDays / 7);
//   };
//    const getPaymentStats = () => {
//   if (!customer) return { weeks: [], pending: 0, lastPayment: null };

//   const weekly = Number(customer.weekly_interest_amount);
//   const completedWeeks = getCompletedWeeks(customer.given_date);

//   /* last payment */
//   const lastPayment = payments.length
//     ? [...payments].sort(
//         (a, b) => new Date(b.payment_date) - new Date(a.payment_date),
//       )[0]
//     : null;

//   /* week map */
//   const weekMap = {};
//   payments.forEach((p) => {
//     const w = Number(p.week_number);
//     weekMap[w] = (weekMap[w] || 0) + Number(p.paid_amount);
//   });

//   const maxPaidWeek = Math.max(0, ...Object.keys(weekMap).map(Number));
//   const maxWeekToShow = Math.max(completedWeeks, maxPaidWeek);

//   /* ✅ CORRECT PENDING (SAME AS PaymentList) */
//   let pending = completedWeeks * weekly;

//   payments.forEach((p) => {
//     const extra = Math.max(Number(p.paid_amount) - weekly, 0);
//     pending -= extra;
//   });

//   pending = Math.max(pending, 0);

//   /* weeks for UI */
//   const weeks = [];
//   for (let w = 1; w <= maxWeekToShow; w++) {
//     const paid = weekMap[w] || 0;
//     weeks.push({
//       week: w,
//       paid,
//       status: paid > 0 ? "PAID" : "NOT_PAID",
//     });
//   }

//   return { weeks, pending, lastPayment };
// };


//   /* ================= ORIGINAL AMOUNT STATEMENT ================= */

//   const buildOriginalStatement = () => {
//     if (!customer) return [];

//     // calculate original principal safely
//     const totalPaid = originalPayments.reduce(
//       (sum, p) => sum + Number(p.amount),
//       0,
//     );

//     const principal = Number(customer.investment_amount) + totalPaid;

//     let balance = principal;

//     const rows = [];

//     // 🔹 FIRST ROW – INVESTMENT GIVEN
//     rows.push({
//       date: customer.given_date,
//       description: "Initial Investment",
//       amount: principal,
//       balance: principal,
//       type: "credit",
//     });

//     // 🔹 PAYMENTS (SORTED BY DATE)
//     const sorted = [...originalPayments].sort(
//       (a, b) => new Date(a.pay_date) - new Date(b.pay_date),
//     );

//     sorted.forEach((p) => {
//       balance -= Number(p.amount);
//       if (balance < 0) balance = 0;

//       rows.push({
//         date: p.pay_date,
//         description: "Paid",
//         amount: p.amount,
//         balance,
//         type: "debit",
//       });
//     });

//     return rows;
//   };

//   if (loading) {
//     return (
//       <div className="flex items-center justify-center min-h-screen">
//         <div className="animate-spin h-10 w-10 border-b-2 border-indigo-600 rounded-full"></div>
//       </div>
//     );
//   }

//   const { weeks, pending, lastPayment } = getPaymentStats();
//   const originalStatement = buildOriginalStatement();

//   return (
//     <div className="min-h-screen bg-gray-50 p-6">
//       <div className="max-w-6xl mx-auto space-y-6">
//         {/* BACK */}
//         <button
//           onClick={() => navigate("/admin/customers")}
//           className="text-sm text-gray-600 hover:text-indigo-600"
//         >
//           ← Back to Customers
//         </button>

//         {/* HEADER */}
//         <div className="bg-white p-6 rounded-xl shadow border">
//           <h1 className="text-2xl font-bold">{customer.name}</h1>
//           <p className="text-gray-500">
//             {customer.co_name} •{" "}
//             <span className="font-mono text-indigo-600">
//               {customer.customer_code}
//             </span>
//           </p>
//         </div>

//         {/* SUMMARY */}
//         <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
//           <div className="bg-indigo-50 p-4 rounded-lg">
//             <p className="text-xs font-bold text-gray-500">PRINCIPAL</p>
//             <p className="text-lg font-black text-indigo-700">
//               ₹{originalStatement[0].balance.toLocaleString()}
//             </p>
//           </div>

//           <div className="bg-emerald-50 p-4 rounded-lg">
//             <p className="text-xs font-bold text-gray-500">WEEKLY INTEREST</p>
//             <p className="text-lg font-black text-emerald-700">
//               ₹{Number(customer.weekly_interest_amount).toLocaleString()}
//             </p>
//           </div>

//           <div className="bg-red-50 p-4 rounded-lg">
//             <p className="text-xs font-bold text-gray-500">TOTAL PENDING</p>
//             <p className="text-lg font-black text-red-700">
//               ₹{pending.toLocaleString()}
//             </p>
//           </div>

//           <div className="bg-gray-100 p-4 rounded-lg">
//             <p className="text-xs font-bold text-gray-500">LAST PAYMENT</p>
//             <p className="text-sm font-semibold">
//               {lastPayment ? lastPayment.payment_date : "-"}
//             </p>
//           </div>
//         </div>

//         {/* WEEKLY STATUS */}
//         <div className="bg-white p-6 rounded-xl shadow border">
//           <h3 className="text-lg font-bold mb-4">Weekly Status</h3>
//           <div className="overflow-x-auto">
//             <div className="flex min-w-max border">
//               {weeks.map((w) => (
//                 <div
//                   key={w.week}
//                   className={`min-w-[80px] text-center border-r text-xs font-bold ${
//                     w.status === "PAID"
//                       ? "bg-green-100 text-green-700"
//                       : "bg-red-100 text-red-700"
//                   }`}
//                 >
//                   <div className="border-b bg-gray-200 py-1">W{w.week}</div>
//                   <div className="py-3">₹{w.paid}</div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>

//         {/* 🔥 ORIGINAL AMOUNT STATEMENT */}
//         <div className="bg-white p-6 rounded-xl shadow border">
//           <h3 className="text-lg font-bold mb-4">Original Amount Statement</h3>

//           <table className="w-full border">
//             <thead className="bg-gray-100">
//               <tr>
//                 <th className="p-2 border">Date</th>
//                 <th className="p-2 border">Description</th>
//                 <th className="p-2 border">Amount</th>
//                 <th className="p-2 border">Balance</th>
//               </tr>
//             </thead>
//             <tbody>
//               {originalStatement.map((r, i) => (
//                 <tr key={i}>
//                   <td className="p-2 border">{r.date}</td>
//                   <td className="p-2 border font-semibold">{r.description}</td>
//                   <td
//                     className={`p-2 border font-bold ${
//                       r.type === "credit" ? "text-indigo-700" : "text-red-600"
//                     }`}
//                   >
//                     {r.type === "credit" ? "+" : "-"}₹
//                     {Number(r.amount).toLocaleString()}
//                   </td>
//                   <td className="p-2 border font-bold text-green-700">
//                     ₹{Number(r.balance).toLocaleString()}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>

//         {/* ACCOUNT DETAILS */}
//         <div className="bg-white p-6 rounded-xl shadow border">
//           <h3 className="text-lg font-bold mb-4">Account Details</h3>
//           <div className="space-y-2 text-sm">
//             <div>
//               <b>Mobile:</b> {customer.mobile1}
//             </div>
//             <div>
//               <b>Address:</b> {customer.address || "-"}
//             </div>
//             <div>
//               <b>Status:</b>{" "}
//               <span
//                 className={`font-bold ${
//                   customer.status === "Close"
//                     ? "text-red-600"
//                     : "text-green-600"
//                 }`}
//               >
//                 {customer.status}
//               </span>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CustomerDetails;


import React, { useEffect, useState } from "react";

import { Api } from "../Api/Api";
import { useParams, useNavigate, useLocation } from "react-router-dom";

const CustomerDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [advances, setAdvances] = useState([]);


  const [customer, setCustomer] = useState(null);
  const [payments, setPayments] = useState([]);
  const [originalPayments, setOriginalPayments] = useState([]);
  const [loading, setLoading] = useState(true);

  const location = useLocation();
  const fromPage = location.state?.from;

  useEffect(() => {
    fetchCustomerData();
  }, [id]);


  const currentUser = JSON.parse(localStorage.getItem("currentUser"));
const role = currentUser?.role; // "admin" | "staff"


 
  const fetchCustomerData = async () => {
    try {
      /* ================= CUSTOMER ================= */
   
      const customerRes = await fetch(`${Api}customers/get.php?id=${id}`);

      const customerData = await customerRes.json();

      if (!customerData.status) {
        alert("Customer not found");
        navigate("/admin/customers");
        return;
      }

      setCustomer(customerData.customer);

      /* ================= PAYMENTS ================= */
  
      const paymentsRes = await fetch(`${Api}payments/list.php`);
      const paymentsData = await paymentsRes.json();

      setPayments(
        (paymentsData.payments || []).filter(
          (p) => Number(p.customer_id) === Number(id),
        ),
      );

      /* ================= ORIGINAL PAYMENTS ================= */

      const originalRes = await fetch(
        `${Api}payments/list-original-payments.php`,
      );
      

      const originalData = await originalRes.json();

      setOriginalPayments(
        (originalData.payments || []).filter(
          (p) => Number(p.customer_id) === Number(id),
        ),
      );

      /* ================= ADVANCES (🔥 FIXED) ================= */
    
      const advancesRes = await fetch(`${Api}advances/list.php`);

      const advancesData = await advancesRes.json();

      setAdvances(
        (advancesData.advances || []).filter(
          (a) =>
            // primary match
            Number(a.customer_id) === Number(id) ||
            // fallback match (your current backend)
            a.customer_code === customerData.customer.customer_code,
        ),
      );
    } catch (err) {
      console.error(err);
    }

    setLoading(false);
  };

  if (loading || !customer) return null;

  /* ================= WEEK HELPERS ================= */

  const getCompletedWeeks = (givenDate) => {
    const start = new Date(givenDate);
    const today = new Date();
    start.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    const diffDays = Math.floor((today - start) / 86400000);
    return Math.floor(diffDays / 7);
  };

  // ✅ PAID → payment date | NOT PAID → scheduled date
  const getWeekDisplayDate = (givenDate, weekNo, paidDate) => {
    if (paidDate) {
      return new Date(paidDate).toLocaleDateString("en-IN");
    }
    const d = new Date(givenDate);
    d.setDate(d.getDate() + weekNo * 7);
    return d.toLocaleDateString("en-IN");
  };

 
  const getPaymentStats = () => {
    if (!customer) return { weeks: [], pending: 0, lastPayment: null };

    const weekly = Number(customer.weekly_interest_amount || 0);
    const completedWeeks = getCompletedWeeks(customer.given_date);

    const lastPayment = payments.length
      ? [...payments].sort(
          (a, b) => new Date(b.payment_date) - new Date(a.payment_date),
        )[0]
      : null;

    const weekMap = {};
    const weekPaymentDate = {};

    payments.forEach((p) => {
      const w = Number(p.week_number);
      weekMap[w] = (weekMap[w] || 0) + Number(p.paid_amount || 0);

      if (
        !weekPaymentDate[w] ||
        new Date(p.payment_date) > new Date(weekPaymentDate[w])
      ) {
        weekPaymentDate[w] = p.payment_date;
      }
    });

 
    const maxPaidWeek = Math.max(0, ...Object.keys(weekMap).map(Number));
    const maxWeekToShow = Math.max(completedWeeks + 1, maxPaidWeek + 1);

    const nextComingWeek = Math.max(completedWeeks + 1, maxPaidWeek + 1);


    // ✅🔥 FIXED PENDING (SAME AS PAYMENT LIST & DASHBOARD)
    const totalDue = completedWeeks * weekly;

    const totalPaid = payments.reduce(
      (sum, p) => sum + Number(p.paid_amount || 0),
      0,
    );

    const pending = Math.max(totalDue - totalPaid, 0);


    const weeks = [];
    for (let w = 1; w <= maxWeekToShow; w++) {
      const paid = weekMap[w] || 0;

      let status = "NOT_PAID";
      if (paid > 0) status = "PAID";
      else if (w === nextComingWeek) status = "UPCOMING";

      weeks.push({
        week: w,
        paid,
        date: getWeekDisplayDate(customer.given_date, w, weekPaymentDate[w]),
        status,
      });
    }


    return { weeks, pending, lastPayment };
  };



  const totalPaid = payments.reduce(
  (sum, p) => sum + Number(p.paid_amount || 0),
  0
);


  /* ================= ORIGINAL STATEMENT ================= */

  const buildOriginalStatement = () => {
    if (!customer) return [];

    const totalPaid = originalPayments.reduce(
      (sum, p) => sum + Number(p.amount),
      0,
    );

    const principal = Number(customer.investment_amount) + totalPaid;
    let balance = principal;

    const rows = [
      {
        date: customer.given_date,
        description: "Initial Investment",
        amount: principal,
        balance: principal,
        type: "credit",
      },
    ];

    [...originalPayments]
      .sort((a, b) => new Date(a.pay_date) - new Date(b.pay_date))
      .forEach((p) => {
        balance -= Number(p.amount);
        if (balance < 0) balance = 0;
        rows.push({
          date: p.pay_date,
          description: "Paid",
          amount: p.amount,
          balance,
          type: "debit",
        });
      });

    return rows;
  };

  if (loading) return null;

  const { weeks, pending, lastPayment } = getPaymentStats();
  const originalStatement = buildOriginalStatement();

  const formatMMDDYYYY = (dateStr) => {
    if (!dateStr) return "-";

    const d = new Date(dateStr);
    if (isNaN(d)) return dateStr;

    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    const yyyy = d.getFullYear();

    return `${mm}-${dd}-${yyyy}`;
  };



  const currentPrincipalBalance =
    originalStatement.length > 0
      ? originalStatement[originalStatement.length - 1].balance
      : 0;

const formatDateTime = (dateStr) => {
  if (!dateStr) return "-";
  const d = new Date(dateStr);
  if (isNaN(d)) return dateStr;

  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();

  const hh = String(d.getHours()).padStart(2, "0");
  const min = String(d.getMinutes()).padStart(2, "0");

  return `${dd}-${mm}-${yyyy} ${hh}:${min}`;
};

      

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-6xl mx-auto space-y-6">
        <button
          // onClick={() =>
          //   navigate(
          //     role === "admin"
          //       ? "/admin/customers"
          //       : "/staff/customers"
          //   )
          // }

          onClick={() => {
            if (fromPage === "deduct-profit") {
              navigate("/admin/deduct-profit");
            } else if (fromPage === "today-pending") {
              navigate("/admin/today-pending");
            } else {
              navigate(
                role === "admin" ? "/admin/customers" : "/staff/customers",
              );
            }
          }}
          className="text-sm text-gray-600 hover:text-indigo-600"
        >
          ← Back to Customers
        </button>

        <div className="bg-white p-6 rounded-xl shadow border flex items-center gap-6">
          {/* PHOTO */}
          {customer.photo_url ? (
            <img
              src={customer.photo_url}
              alt="Customer"
              className="w-24 h-24 rounded-lg object-cover border shadow-sm"
            />
          ) : (
            <div className="w-24 h-24 rounded-lg bg-gray-100 flex items-center justify-center text-xs text-gray-400 border">
              No Photo
            </div>
          )}

          {/* BASIC INFO */}
          <div>
            <h1 className="text-2xl font-bold">{customer.name}</h1>
            <p className="text-gray-500">
              {customer.co_name} •{" "}
              <span className="font-mono text-indigo-600">
                {customer.customer_code}
              </span>
            </p>

            <p className="text-sm mt-1 text-gray-600">
              <b>Created By:</b> {customer.created_by || "-"}
            </p>

            <div className="text-sm mt-1 text-gray-600">
              {formatDateTime(customer.created_at)}
            </div>
          </div>
        </div>

        {/* SUMMARY */}
        <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
          <div className="bg-indigo-50 p-4 rounded-lg">
            <p className="text-xs font-bold text-gray-500">PRINCIPAL</p>

            <p className="text-lg font-black text-indigo-700">
              ₹{currentPrincipalBalance.toLocaleString()}
            </p>
          </div>

          <div className="bg-emerald-50 p-4 rounded-lg">
            <p className="text-xs font-bold text-gray-500">WEEKLY INTEREST</p>
            <p className="text-lg font-black text-emerald-700">
              ₹{Number(customer.weekly_interest_amount).toLocaleString()}
            </p>
          </div>

          <div className="bg-blue-50 p-4 rounded-lg">
            <p className="text-xs font-bold text-gray-500">Total Collection</p>
            <p className="text-lg font-black text-blue-700">
              ₹{totalPaid.toLocaleString()}
            </p>
          </div>

          <div className="bg-red-50 p-4 rounded-lg">
            <p className="text-xs font-bold text-gray-500">TOTAL PENDING</p>
            <p className="text-lg font-black text-red-700">
              ₹{pending.toLocaleString()}
            </p>
          </div>

          <div className="bg-gray-100 p-4 rounded-lg">
            <p className="text-xs font-bold text-gray-500">LAST PAYMENT</p>

            <p className="text-sm font-semibold">
              {lastPayment
                ? (() => {
                    const d = new Date(lastPayment.payment_date);
                    if (isNaN(d)) return lastPayment.payment_date;

                    const dd = String(d.getDate()).padStart(2, "0");
                    const mm = String(d.getMonth() + 1).padStart(2, "0");
                    const yyyy = d.getFullYear();

                    return `${dd}-${mm}-${yyyy}`;
                  })()
                : "-"}
            </p>
          </div>
        </div>

        {/* WEEKLY STATUS */}
        <div className="bg-white p-6 rounded-xl shadow border">
          <h3 className="text-lg font-bold mb-4">Weekly Status</h3>
          <div className="overflow-x-auto">
            <div className="flex min-w-max border">
              {weeks.map((w) => (
                <div
                  key={w.week}
                  className={`min-w-[95px] text-center border-r text-xs font-bold ${
                    w.status === "PAID"
                      ? "bg-green-500 text-green-1200"
                      : w.status === "UPCOMING"
                        ? "bg-yellow-500 text-yellow-1200"
                        : "bg-red-500 text-red-1200"
                  }`}
                >
                  <div className="border-b bg-gray-200 py-1 leading-tight">
                    <div>W{w.week}</div>
                    <div className="text-[10px] text-gray-600">{w.date}</div>
                  </div>
                  <div className="py-3">₹{w.paid}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* OTHER SECTIONS UNCHANGED */}

        {/* --- Original Amount Statement --- */}
        <div className="bg-white p-6 rounded-xl shadow border">
          <h3 className="text-lg font-bold mb-4">Loan Amount Statement</h3>

          {/* Added overflow wrapper */}
          <div className="overflow-x-auto">
            <table className="w-full border min-w-[600px]">
              {" "}
              {/* min-w ensures table doesn't squish too much */}
              <thead className="bg-gray-100">
                <tr>
                  <th className="p-2 border">Date</th>
                  <th className="p-2 border">Description</th>
                  <th className="p-2 border">Amount</th>
                  <th className="p-2 border">Balance</th>
                </tr>
              </thead>
              <tbody>
                {originalStatement.map((r, i) => (
                  <tr key={i}>
                    {/* <td className="p-2 border whitespace-nowrap">{r.date}</td> */}
                    <td className="p-2 border whitespace-nowrap">
                      {formatMMDDYYYY(r.date)}
                    </td>

                    <td className="p-2 border font-semibold whitespace-nowrap">
                      {r.description}
                    </td>
                    <td
                      className={`p-2 border font-bold whitespace-nowrap ${
                        r.type === "credit" ? "text-indigo-700" : "text-red-600"
                      }`}
                    >
                      {r.type === "credit" ? "+" : "-"}₹
                      {Number(r.amount).toLocaleString()}
                    </td>
                    <td className="p-2 border font-bold text-green-700 whitespace-nowrap">
                      ₹{Number(r.balance).toLocaleString()}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* --- Advance Usage --- */}
        <div className="bg-white p-6 rounded-xl shadow border mt-6">
          <h3 className="text-lg font-bold mb-4">Advance Usage</h3>

          {advances.length === 0 ? (
            <p className="text-sm text-gray-500">No advances taken.</p>
          ) : (
            /* Added overflow wrapper */
            <div className="overflow-x-auto">
              <table className="w-full text-sm border min-w-[800px]">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="p-2 border">#</th>
                    <th className="p-2 border">Advanced Date</th>
                    <th className="p-2 border">Original</th>
                    <th className="p-2 border">Used</th>
                    <th className="p-2 border">Remaining</th>
                    <th className="p-2 border">Weeks</th>
                  </tr>
                </thead>

                <tbody>
                  {advances.map((a, i) => {
                    const total = Number(a.advance_amount);
                    const used = Number(a.used_amount || 0);
                    const remaining = total - used;

                    return (
                      <tr key={a.id} className="border-t">
                        <td className="p-2 text-center">{i + 1}</td>
                        {/* <td className="p-2 text-center whitespace-nowrap">
                          {a.advance_date}
                        </td> */}
                        <td className="p-2 text-center whitespace-nowrap">
                          {(() => {
                            if (!a.advance_date) return "-";
                            const d = new Date(a.advance_date);
                            if (isNaN(d)) return a.advance_date;

                            const dd = String(d.getDate()).padStart(2, "0");
                            const mm = String(d.getMonth() + 1).padStart(
                              2,
                              "0",
                            );
                            const yyyy = d.getFullYear();

                            return `${dd}-${mm}-${yyyy}`;
                          })()}
                        </td>

                        <td className="p-2 text-right font-bold whitespace-nowrap">
                          ₹{total}
                        </td>
                        <td className="p-2 text-right text-red-600 whitespace-nowrap">
                          ₹{used}
                        </td>
                        <td className="p-2 text-right text-green-700 font-bold whitespace-nowrap">
                          ₹{remaining}
                        </td>

                        <td className="p-2">
                          {a.weeks?.length ? (
                            /* The inner week detail table is also protected by min-width */
                            <div className="border rounded text-xs min-w-[250px]">
                              <div className="grid grid-cols-3 bg-gray-200 font-bold text-center">
                                <div className="p-1">Week</div>
                                <div className="p-1">Amount</div>
                                <div className="p-1">Date</div>
                              </div>

                              {a.weeks.map((w) => (
                                <div
                                  key={w.id}
                                  className="grid grid-cols-3 border-t text-center"
                                >
                                  <div className="p-1 font-semibold whitespace-nowrap">
                                    W-{w.week_no}
                                  </div>
                                  <div className="p-1 text-green-700 font-bold whitespace-nowrap">
                                    ₹{w.paid_amount}
                                  </div>
                                  <div className="p-1 text-gray-600 whitespace-nowrap">
                                    {w.paid_date}
                                  </div>
                                </div>
                              ))}
                            </div>
                          ) : (
                            <span className="text-gray-400 text-xs">
                              No weeks
                            </span>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>

        {/* ACCOUNT DETAILS */}
        <div className="bg-white p-6 rounded-xl shadow border">
          <h3 className="text-lg font-bold mb-4">Account Details</h3>
          <div className="space-y-2 text-sm">
            <div>
              <b>Mobile:</b> {customer.mobile1}
            </div>
            <div>
              <b>Address:</b> {customer.address || "-"}
            </div>
            <div>
              <b>Status:</b>{" "}
              <span
                className={`font-bold ${
                  customer.status === "Close"
                    ? "text-red-600"
                    : "text-green-600"
                }`}
              >
                {customer.status}
              </span>
            </div>

            {customer.notes && (
              <div className="bg-white p-6 rounded-xl shadow border">
                <h3 className="text-lg font-bold mb-2">Notes</h3>
                <p className="text-sm text-gray-700 whitespace-pre-wrap">
                  {customer.notes}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerDetails;


